import privilege from "@/apis/tg_business/agent/privilege";

export default {
  privilege,
};
